if (!customElements.get('tru-mobile-purchase')) {
  customElements.define('tru-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      const section = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
      const form = document.getElementById(`product-form-${this.dataset.sectionId}`);
      const submit = form?.querySelector('[name="add"]');
      const price = document.getElementById(`price-${this.dataset.sectionId}`);
      if (!section || !submit || !price) return;
      const button = this.querySelector('button');
      const priceTarget = this.querySelector('.tru-mobile-purchase__price');
      const sync = () => {
        const zeroPrice = form.dataset.zeroPrice === 'true';
        button.style.display = zeroPrice ? 'none' : '';
        if (zeroPrice) {
          button.disabled = true;
          priceTarget.textContent = 'İnternet Stoğu tükendi';
          return;
        }
        button.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
        button.textContent = submit.classList.contains('loading') ? 'Ekleniyor…' : submit.innerText.trim();
        const copy = price.cloneNode(true);
        copy.removeAttribute('id');
        copy.removeAttribute('role');
        copy.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
        priceTarget.replaceChildren(...copy.childNodes);
      };
      this.onClick = () => {
        if (button.disabled) return;
        submit.click();
        if (!form.checkValidity()) form.reportValidity();
      };
      button.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(sync);
      this.observer.observe(form, { attributes: true, attributeFilter: ['data-zero-price'] });
      this.observer.observe(submit, { childList: true, subtree: true, characterData: true, attributes: true });
      this.observer.observe(price, { childList: true, subtree: true, characterData: true, attributes: true });
      this.intersection = new IntersectionObserver(([entry]) => { this.hidden = entry.isIntersecting; });
      this.intersection.observe(submit);
      const error = section.querySelector('.product-form__error-message-wrapper');
      if (error) {
        this.errorObserver = new MutationObserver(() => {
          if (!error.hidden) error.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        this.errorObserver.observe(error, { attributes: true, attributeFilter: ['hidden'] });
      }
      sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.errorObserver?.disconnect();
      this.querySelector('button')?.removeEventListener('click', this.onClick);
      this.observer = null;
    }
  });
}
